// Generated by scripts/check-telemetry-release-env.ts during release builds.
export const BUNDLED_POSTHOG_TOKEN = "phc_pUZ2ZCRtFkC5qCGDNYcoYEhxxjTaooH57Cj4PTRXovyB" as string | undefined;
export const BUNDLED_SENTRY_DSN = "https://c66cfd76aad69209bcf44be4cd79f9b5@o4508042228006912.ingest.us.sentry.io/4511620382392320" as string | undefined;
